module.exports = __webpack_public_path__ + "img/warning.58a50d15.svg";